import { render, staticRenderFns } from "./submitForReview.vue?vue&type=template&id=374ae333&scoped=true"
import script from "./submitForReview.vue?vue&type=script&lang=js"
export * from "./submitForReview.vue?vue&type=script&lang=js"
import style0 from "./submitForReview.vue?vue&type=style&index=0&id=374ae333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ae333",
  null
  
)

export default component.exports